import { createContext, useContext, useState, useCallback } from 'react'
import en from './translations/en'
import ptBR from './translations/pt-BR'

const LANG_KEY = 'unity-lang'
const translations = { en, 'pt-BR': ptBR }

const LanguageContext = createContext(null)

function getNestedValue(obj, path) {
  return path.split('.').reduce((acc, key) => acc?.[key], obj)
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem(LANG_KEY) || 'en'
    } catch {
      return 'en'
    }
  })

  const setLanguage = useCallback((newLang) => {
    setLangState(newLang)
    try {
      localStorage.setItem(LANG_KEY, newLang)
    } catch { /* ignore */ }
  }, [])

  const t = useCallback((key, params) => {
    const dict = translations[lang] || translations.en
    let value = getNestedValue(dict, key)
    if (value === undefined) {
      value = getNestedValue(translations.en, key)
    }
    if (value === undefined) return key
    if (params) {
      value = value.replace(/\{(\w+)\}/g, (_, k) => params[k] ?? `{${k}}`)
    }
    return value
  }, [lang])

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useTranslation() {
  const ctx = useContext(LanguageContext)
  if (!ctx) throw new Error('useTranslation must be used within LanguageProvider')
  return ctx
}

export default LanguageContext
